<div
  class="referral-decline"
  *transloco="let t">
  <app-referral-decline-img [done]="isRemovalDone"></app-referral-decline-img>

  <ng-container *ngIf="!isRemovalDone; else removedBlock">
    <h1 class="referral-decline_title">
      {{ t('referrals.decline-referral') }}
    </h1>
    <p
      class="referral-decline_description"
      [innerHTML]="t('referrals.decline-referral-description')"></p>

    <button
      class="btn __l referral-decline_button"
      (click)="decline()"
      [disabled]="isInProgress"
      ngPreserveWhitespaces>
      <i
        class="spinner"
        *ngIf="isInProgress"></i>
      {{ t('common.decline') }}
    </button>
  </ng-container>

  <ng-template #removedBlock>
    <h1 class="referral-decline_title">
      {{ t('referrals.referral-has-been-declined') }}
    </h1>
    <p
      class="referral-decline_description"
      [innerHTML]="t('referrals.declined-referral-description')"></p>
  </ng-template>
</div>
